import React, { useState, useEffect } from "react";
import {Accordion, Alert, Button, Col, Row} from "react-bootstrap";
import {Redirect, useHistory} from "react-router-dom";
import { useSubheader } from "@metronic/layout";
import axios from "axios";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import { InssuredFile } from "@components/panels/insured-file/inssured-file";
import { MedicalDataAdditional } from "@components/panels/additional-medical-data/medical-data-additional";
import {
  getBySlug,
  update,
} from "@services/hospitalization"
import { isEmpty } from "@utils/check-object-empty";
import { getLetterMovsByCase } from "@services/letter-movements";
import moment from "moment";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import { getAllMedicalFees } from "@services/medical-fees";
// import { ProvidersData } from "@components/panels/surgery-providers-data/providers-data"; // deprecado: reemplazado por SurgeryProvidersSection
import { SurgeryProvidersSection } from "@components/panels/surgery-providers-section/surgery-providers-section";
import { REGISTRATION_CASE_TYPE } from '@constants/case-types';
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";
import {INCOME_TYPE} from "@constants/income-types";
import {CASE_TYPE} from "@constants/case-types";
import {CASE_STATUS} from "@constants/case-statuses";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import { useMultiFormManager } from "@contexts/multi-form-manager-context";
import WithMultiFormManager from "@components/shared/with-multi-form-manager";
import { flowRight as compose } from "lodash";
import AmountLetterSufficientModal from "@components/modals/amount-letter-sufficient-modal";
import { getMexicoTimestamp } from "@utils/date-utils";

const MedicalInformationDetails = (props) => {
  const [caseRecord, setCaseRecord] = useState({});
  const [lettersMov, setLettersMov] = useState([]);
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [showAmountLetterSufficientModal, setShowAmountLetterSufficientModal] = useState(false);
  const [requiresTabulation, setRequiresTabulation] = useState(null);

  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();
  const { validateAllForms, getAllFormValues, registeredForms } = useMultiFormManager();
  const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
  const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
    caseData: caseRecord,
    eventStage: null,
    comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
    isPageable: false,
    hideReason: true,
  });

  const { slug } = props.match.params;

  useEffect(() => {
    subheader.setTitle("INFORMACIÓN MÉDICA");

    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      window.requires_tabulation = response.data.requiresTabulation;
      window.requires_surgery_providers = response.data.requiresSurgeryProviders;
      setRequiresTabulation(response.data.requiresTabulation === "Si" ? true : response.data.requiresTabulation === "No" ? false : null);
      getLetterMovsByCase(response.data.id).then((currrentLettersMov) => setLettersMov(currrentLettersMov.data));
    });
  }, [slug]);

  let history = useHistory();

  const handleCommonValidationsAndSubmit = async () => {
    if (!window.requires_tabulation) {
      alert("El campo requiere tabulacion es obligatorio");
      return false;
    }

    const validation = await validateAllForms();
    if (!validation.allValid) return false;

    if (window.requires_tabulation === "Si" && (await getAllMedicalFees(caseRecord.id)).data.length === 0) {
      await registeredForms['medicalFees']?.submit?.();
    }

    return true;
  };

  const onClickSendControlDesk = async (values = {}, selectedOption = null) => {
    const allFormValues = getAllFormValues();

    if (!await handleCommonValidationsAndSubmit() || !validateCommentRequired()) {
      return;
    }

    let statusId = CASE_STATUS.CONTROL_DESK;

    if (selectedOption === 'Y' && values.amountAuthorizationLetter) {
      const isReviewCutOrHospitalDischarge = [CASE_TYPE.HOSPITAL_DISCHARGE, CASE_TYPE.CUT_REVIEW].includes(caseRecord.caseType);
      const authAmount = parseFloat(String(values.amountAuthorizationLetter).replace(/,/g, '') || 0);
      const expenseAmount = parseFloat(String(values.hospitalizationExpenseAmount).replace(/,/g, '') || 0);

      if (authAmount < expenseAmount && isReviewCutOrHospitalDischarge) {
        statusId = CASE_STATUS.CONTROL_DESK;
      } else if (authAmount > expenseAmount && isReviewCutOrHospitalDischarge) {
        statusId = caseRecord.caseType === CASE_TYPE.HOSPITAL_DISCHARGE && values.requiresAdditionalTabLetter === 'si' 
          ? CASE_STATUS.CONTROL_DESK 
          : CASE_STATUS.COST_CONTROL;
      }
    }

    const timestamp = getMexicoTimestamp();
    const updateData = {
      caseStatusId: statusId,
      requiresTabulation: window.requires_tabulation || null,
      requiresSurgeryProviders: window.requires_surgery_providers || null,
      ...(statusId === CASE_STATUS.CONTROL_DESK && { feamesaControl: timestamp }),
      ...(statusId === CASE_STATUS.COST_CONTROL && { feaccostos: timestamp }),
      ...(REGISTRATION_CASE_TYPE.includes(document.getElementById('caseTypeOther')?.value) && 
          !caseRecord.hospitalDateHire && { hospitalDateHire: timestamp }),
      ...allFormValues.inssuredFile || {},
    };

    await saveCommentAutomatically();
    await saveCommentAutomaticallyUnam();
    await update(updateData, caseRecord.id);
    setShowAmountLetterSufficientModal(false);
    history.push("/informacion_medica");
  };

  const onClickSave = async () => {
    const allFormValues = getAllFormValues();

    if (!await handleCommonValidationsAndSubmit()) return;

    await update({
      requiresTabulation: window.requires_tabulation || null,
      requiresSurgeryProviders: window.requires_surgery_providers || null,
      ...allFormValues.inssuredFile || {},
    }, caseRecord.id);
    
    await saveCommentAutomatically();
    await saveCommentAutomaticallyUnam();
    history.push("/informacion_medica");
  };

  const handleAmountLetterSufficientModal = () => {
    setShowAmountLetterSufficientModal(!showAmountLetterSufficientModal);
  }

  if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.MEDIC_INFORMATION])) {
    return <Redirect to="/error/unauthorized"/>;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Informacion Medica
      </Alert>

      <CaseHeader
        showUnamAlert={true}
        caseRecord={caseRecord}
        requiresTabulationSlot={
          <>
            <b>Tabulacion: </b>
            {caseRecord.requiresTabulation}
          </>
        }
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion defaultActiveKey="6" className="mt-5">
          <MedicalDataAdditional
            icon ="fa-search"
            eventKey="6"
            data={caseRecord}
            bindSubmitForm={() => {}}
            disabled={true}
          />
        </Accordion>
        <Accordion defaultActiveKey="0" className="mt-5">
          <Documentation
            icon= "fa-pencil-alt"
            eventKey="4"
            data={caseRecord}
            disabledAll={false}
            typesDocument={[
              "Aviso de Accidente", "Carta de Autorización", "Comprobante de Seguro o Póliza", "Denuncia ante MP",
              "Estado de Cuenta Parcial", "Estado de Cuenta Final", "Estudios de Gabinete", "Estudios de Laboratorio",
              "Estudios que Confirmen DX", "Historia Clínica", "Identificación", "Informe Medico Actualizad",
              "Nota de Evolución", "Nota Postquirúrgica", "Resumen Medico Actualizado", "Nota de Remisión", "Sabana Quirurgica", "Otro",
            ]}
            {...props}
          />
          <MedicalFees
            icon= "fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            bindSubmitForm={() => {}}
            bindErrors={() => {}}
            onRequiresTabChange={setRequiresTabulation}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="3"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={setTotalLetters}
            {...props}
          />
          <InssuredData
            icon="fa-search"
            eventKey="1"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <HospitalData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <SurgeryProvidersSection
            icon="fa-pencil-alt"
            eventKey="7"
            data={caseRecord}
            disabled={caseRecord?.hospital?.surgeryProvider !== 1}
            {...props}
          />
          {/* Deprecado: panel "Proveedores de cirugia" (proveedores médicos) reemplazado por <SurgeryProvidersSection>.
              Si se requiere reactivar, restaurar también `requiresProviders: window.requires_providers || null`
              en los payloads de onClickSendControlDesk y onClickSave, y el import de ProvidersData arriba.
          <ProvidersData
            icon= "fa-pencil-alt"
            eventKey="6"
            data={caseRecord}
            disabled={caseRecord?.hospital?.captProviders !== 1}
            {...props}
          /> */}
          <InssuredFile
            icon="fa-pencil-alt"
            eventKey="0"
            data={caseRecord}
            lettersMov={lettersMov}
            totalLetters={totalLetters}
            hideAmountLetterSufficient={true}
            bindSubmitForm={() => {}}
            bindErrors={() => {}}
          />
        </Accordion>
        <Accordion defaultActiveKey="5" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            disabledAll={false}
            eventStage="Informacion Medica"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>

      <Row>
        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={async (e) => {
              if (caseRecord.caseType === CASE_TYPE.HOSPITAL_DISCHARGE || caseRecord.caseType === CASE_TYPE.CUT_REVIEW) {
                handleAmountLetterSufficientModal(e);
              } else {
                await onClickSendControlDesk();
              }
            }}
          >
            Enviar a Solicitud
          </Button>
        </Col>
        <Col className="mt-5 mr-5" onClick={onClickSave}>
          <Button variant="warning">Guardar Avance</Button>
        </Col>
      </Row>

      <AmountLetterSufficientModal
        show={showAmountLetterSufficientModal}
        onHide={handleAmountLetterSufficientModal}
        onSubmit={onClickSendControlDesk}
      />
    </>
  );
};

export default compose(
  WithCommentValidation,
  WithMultiFormManager
)(MedicalInformationDetails);

